import React from "react";
import { useSearchParams } from "react-router-dom";
import { BreadcrumbSchema, Seo } from "@shared/components";
import { softwareApplicationSchema } from "@shared/config/seo-schemas";
import { useAuth } from "@shared/contexts/auth-context";
import { buildBotUrl } from "@shared/helper_lib/bot-link";
import { PricingCards } from "@widgets/PricingCards";
import { PricingComparison } from "@widgets/PricingComparison";
import { PricingFaq } from "@widgets/PricingFaq";

export const PricingPage: React.FC = () => {
  const { user } = useAuth(); // Получаем пользователя из контекста
  const [searchParams] = useSearchParams();
  const planParam = searchParams.get("plan");
  const recommendedPlan: "trial" | "basic" | "pro" | null =
    planParam === "trial" || planParam === "basic" || planParam === "pro" ? planParam : null;

  return (
    <>
      <Seo
        title="Тарифы и цены на транскрибацию | Polotno"
        description="Пробный период 150 минут за 99 ₽, подписки Basic (450 минут) и Pro (2000 минут), а также пакеты на 100, 500 и 1000 минут. Прозрачные цены без скрытых платежей."
        path="/pricing"
        jsonLd={[softwareApplicationSchema()]}
      />
      <BreadcrumbSchema items={[{ name: "Главная", url: "/" }, { name: "Тарифы" }]} />
      <main>
        <section className="py-16 md:py-24 border-b border-border">
          <div className="container">
            <div className="mx-auto max-w-3xl text-center mb-12">
              <h1 className="text-4xl font-bold text-foreground mb-4 md:text-5xl text-balance">
                Простые, прозрачные тарифы
              </h1>
              <p className="text-lg text-muted-foreground text-pretty">
                Выберите идеальный план для ваших потребностей в транскрипции. Повышайте, понижайте или отменяйте в
                любое время.
              </p>
            </div>
            <PricingCards currentPlan={user?.plan} recommendedPlan={recommendedPlan} />
            <p className="mt-8 text-center text-sm text-muted-foreground">
              Можно пользоваться и через{" "}
              <a
                href={buildBotUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline-offset-4 hover:underline"
              >
                Telegram-бот
              </a>
            </p>
          </div>
        </section>

        <PricingComparison />
        <PricingFaq />
      </main>
    </>
  );
};
